export const MAX_HOURLY = 2000;
export const MAX_CREDIT = 3;
export const SURVEY_RATE = 50;